<template>
  <section class="device_address__modal">
    <div class="header">
      <h4 class="title">
        <span>{{ new_address.name }}</span>
      </h4>
    </div>

    <div class="content">
      <div class="form-item">
        <fg-input
            v-model="new_address.ip"
            type="text"
            :label="translate('config.ip')"
            :placeholder="translate('config.ip')"
        />
      </div>

      <div class="form-item">
        <fg-input
            v-model="new_address.ports"
            type="number"
            :label="translate('config.ports')"
            :placeholder="translate('config.ports')"
        />
      </div>

    </div>

    <div class="text-center">
      <span
          v-if="changes"
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="update_address"
      >
        {{ translate('btn.edit') }}
      </span>

      <span
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="cancel"
      >
        {{ translate('btn.cancel') }}
      </span>

      <span v-if="new_address.ip === null"
          class="btn btn-apply btn-fill btn-wd"
          @click.prevent="find_address"
      >
        {{ translate('config.find_address') }}
      </span>

      <span
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="delete_address"
      >
        {{ translate('btn.delete') }}
      </span>
    </div>
    <div class="clearfix" />
  </section>
</template>

<script>


export default {
  name: "EditDeviceAddressesModal",
  props: ['address'],
  data () {
    return {
      new_address: {}
    }
  },
  computed:{
    changes(){
      return JSON.stringify([this.address.ip, +this.address.ports]) !== JSON.stringify([this.new_address.ip, +this.new_address.ports])
    }
  },
  created() {
    this.new_address = Object.assign({}, this.address)
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    update_address(){
      this.$http.v1.updateDeviceAddress(this.new_address.id, {ip: this.new_address.ip, ports: this.new_address.ports}, () => {
        this.global_notify('info', this.translate('config.success_update_device_address'))
        this.$emit("update")
      }, (bad_answer) => {
        this.global_notify('info', this.translate('config.error_update_device_address'))
        this.bad_answer_handler(bad_answer)
      })
    },
    find_address(){
      this.$http.v1.findDeviceAddress(this.new_address.id, () => {
        this.global_notify('info', this.translate('config.success_find_device_address'))
        this.$emit("update")
      }, (bad_answer) => {
        this.global_notify('info', this.translate('config.error_find_device_address'))
        this.bad_answer_handler(bad_answer)
      })
    },
    delete_address(){
      this.$http.v1.removeDeviceAddress(this.new_address.id, () => {
        this.global_notify('info', this.translate('config.success_delete_device_address'))
        this.$emit("update")
      }, (bad_answer) => {
        this.global_notify('info', this.translate('config.error_delete_device_address'))
        this.bad_answer_handler(bad_answer)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .device_address__modal{
    padding: 10px;
    .header{
      text-align: center;
      .title{
        margin: 0 0 10px 0;
      }
    }
    .text-center{
      .btn{
        margin-right: 5px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
</style>
